// Surclassements (D-026, suivi D-030) : règles de la note FFBB du 2026-08-10.
// Le coach demande, la famille fournit, le bureau dépose au comité. Valable
// pour la saison ; en vigueur à partir du dépôt au comité (date d'effet).

export type SurclassementKind = 'simple' | 'regional' | 'exceptionnel';
/** « technique » : club avec un responsable technique (D-093), la demande attend l'avis du coach
 *  d'accueil et sa validation avant de partir au bureau. */
export type SurclassementStatus = 'technique' | 'demande' | 'recu' | 'depose' | 'valide' | 'refuse';

export interface SurclassementState { category: string; kind: SurclassementKind; status: SurclassementStatus; effective_on: string | null }

export const KIND_LABEL: Record<SurclassementKind, string> = {
  simple: 'Simple', regional: 'Régional ou national', exceptionnel: 'Exceptionnel',
};
/** Qui délivre et ce qu'il faut réunir, selon le type (note FFBB). */
export const KIND_RULE: Record<SurclassementKind, string> = {
  simple: 'Certificat du médecin de famille, sans imprimé spécifique.',
  regional: 'Certificat d’un médecin agréé. Demande du club validée par le président, avec l’autorisation des parents et l’avis motivé de l’entraîneur.',
  exceptionnel: 'Décidé par la commission médicale fédérale : demande validée par le président, autorisation parentale, dossier médical envoyé à la commission.',
};
export const STATUS_LABEL: Record<SurclassementStatus, string> = {
  technique: 'Chez le resp. technique', demande: 'Demandé', recu: 'Pièces reçues', depose: 'Déposé au comité', valide: 'Validé', refuse: 'Refusé',
};
/** Ordre de traitement pour le bureau : ce qui attend une action d'abord (« technique » n'est pas une étape du bureau). */
export const STATUS_ORDER: SurclassementStatus[] = ['demande', 'recu', 'depose', 'valide', 'refuse'];

/** En vigueur à cette date : déposé au comité (ou validé) et date d'effet atteinte. */
export const inForce = (s: SurclassementState, date: string) =>
  (s.status === 'depose' || s.status === 'valide') && !!s.effective_on && s.effective_on <= date;

/** En cours : demandé, pièces reçues, ou déposé avec une date d'effet à venir. */
export const inProgress = (s: SurclassementState, date: string) =>
  s.status === 'technique' || s.status === 'demande' || s.status === 'recu' || ((s.status === 'depose' || s.status === 'valide') && !inForce(s, date));
